<template>
  <section class="create-team-content">
    <div class="main">
      <div class="first">
         <h3>{{createYourTeam_}}</h3>
         <div class="username">
            {{teamName_}}*
            <br/>
            <input type="text" v-model="name"/>
         </div>
         <!--<div class="country">-->
            <!--{{location_}}*-->
            <!--<br/>-->
            <!--<select v-model="country">-->
              <!--<option v-for="ele in arr" :value="ele[0]">{{ele[1]}}</option>-->
            <!--</select>-->
         <!--</div>-->
         <div class="buttons">
            <div class="error">{{msg}}</div>
            <a class="btn btn-large" @click="submit">{{submit_}}</a>
            <a class="btn btn-large" @click="reset">{{reset_}}</a>
         </div>
         <p class="info">
            *{{changeLogo_}}
         </p>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import countryList from '@/utils/country.js'
  import { newTeam } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        name: '',
        country: '',
        arr: countryList,
        msg: ''
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale']),
      ...mapGetters([]),
      ...i18n.map([
        'createYourTeam_', 'teamName_', 'location_',
        'submit_', 'reset_', 'changeLogo_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      submit () {
        newTeam(this.name, this.country)
          .then((data) => {
            this.$emit('msg', {
              msg: data.msg,
              type: 'info',
              delay: 2000,
              callback: () => {
                this.$router.push('/team')
              }
            })
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      reset () {
        this.name = ''
        this.country = ''
      }
    },
    created () {
      if (!this.profile.name) return this.$router.push('/login')
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/create_team.vue